var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 15.6666C10.7679 15.6666 12.4636 14.9642 13.7139 13.714C14.9641 12.4638 15.6665 10.7681 15.6665 8.99996C15.6665 7.23185 14.9641 5.53616 13.7139 4.28591C12.4636 3.03567 10.7679 2.33329 8.99984 2.33329C7.23173 2.33329 5.53603 3.03567 4.28579 4.28591C3.03555 5.53616 2.33317 7.23185 2.33317 8.99996C2.33317 10.7681 3.03555 12.4638 4.28579 13.714C5.53603 14.9642 7.23173 15.6666 8.99984 15.6666V15.6666ZM8.99984 17.3333C4.39734 17.3333 0.666504 13.6025 0.666504 8.99996C0.666504 4.39746 4.39734 0.666626 8.99984 0.666626C13.6023 0.666626 17.3332 4.39746 17.3332 8.99996C17.3332 13.6025 13.6023 17.3333 8.99984 17.3333ZM8.1665 12.3333H9.83317V14H8.1665V12.3333ZM8.1665 3.99996H9.83317V10.6666H8.1665V3.99996Z",
    fill: "#D53C2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.126c65565ac1107040a5378f1522635b.svg";
export { ForwardRef as ReactComponent };